import { render, staticRenderFns } from "./ReferenceArrayField.vue?vue&type=template&id=589e4b60&"
import script from "./ReferenceArrayField.vue?vue&type=script&lang=js&"
export * from "./ReferenceArrayField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports